module.exports = __webpack_public_path__ + "static/6qed_sq-cf6ef5fc0627fa38cb13975fe96b1673.jpg";